import React from 'react';
import * as Styles from './CloudFlareHeader.styles';
import {
  Button, IconRefresh, IconSecurityCheck, TextField,
  Tooltip,
} from 'gatorcomponents';
import PropTypes from 'prop-types';
import { cloudflareAnalytics } from '@/analytics/cloudflare';

export const CloudFlareHeader = ({
  hostingLabel = 'Hosting Label',
  changeCta = 'change cta',
  cloudflareCdnExplanation,
  searchPerDomainLabel = 'search per domain label',
  refreshStatusLabel,
  noOpenStatusLabel,
  waitRefreshTimeLimitLabel,
  handleRefreshStatus,
  setLastRefreshOnCookie,
  refreshTimeLimitHasEnded,
  hasOpenStatus,
  cloudflareStatusLoading,
  inputedFilter,
  setInputedFilter,
  currentPlan,
  currentDomain,
  handleChangePlan,
  sites,
  title,
}) => {
  const handleClickChangePlan = () => {
    handleChangePlan && handleChangePlan();
  };

  const canRefresh = refreshTimeLimitHasEnded && !cloudflareStatusLoading && hasOpenStatus;
  const refreshTooltipLabel = !hasOpenStatus ? noOpenStatusLabel : waitRefreshTimeLimitLabel;

  const handleClickRefreshStatus = () => {
    const now = Date.now();
    setLastRefreshOnCookie && setLastRefreshOnCookie(now);
    handleRefreshStatus && handleRefreshStatus();
    cloudflareAnalytics.updateStatusCta();
  };

  const handleTypeOnFilter = (e) => {
    setInputedFilter && setInputedFilter(e.target.value);
  };

  const refreshButtonLabel = () => {
    const iconRefreshColor = canRefresh ? 'primaryMedium' : 'lowLight';

    return (
      <>
        {refreshStatusLabel}
        <Styles.IconRefreshContainer loading={cloudflareStatusLoading}>
          <IconRefresh color={iconRefreshColor} direction="mirror" />
        </Styles.IconRefreshContainer>
      </>
    );
  };

  return (
    <Styles.Header data-testid="cloudFlareHeader">
      <Styles.Column>
        <Styles.Title>
          {title}
        </Styles.Title>

        <Styles.CloudFlareCdnExplanation>
          <IconSecurityCheck color="activeMedium" secondaryColor="highPure" />
          <Styles.ExplanationWrapper>
            {cloudflareCdnExplanation}
          </Styles.ExplanationWrapper>
        </Styles.CloudFlareCdnExplanation>

        <Styles.ChangePlanWrapper>
          <Styles.PlanName>
            {`${hostingLabel} ${currentPlan}`}
          </Styles.PlanName>

          <Styles.PlanNameSeparator />

          <Styles.PlanNameRightBlock>
            <Styles.MainDomain>
              {currentDomain}
            </Styles.MainDomain>

            <Button
              testId="change-plan-button"
              variant="text"
              onClick={handleClickChangePlan}
              label={changeCta}
              disabled={sites.length < 2}
            />
          </Styles.PlanNameRightBlock>
        </Styles.ChangePlanWrapper>
      </Styles.Column>

      <Styles.RightColumn>
        <Styles.InputWrapper>
          <TextField
            label={searchPerDomainLabel}
            value={inputedFilter}
            onChange={handleTypeOnFilter}
            traillingIcon="IconSearch"
          />
        </Styles.InputWrapper>
        <Styles.RefreshButtonContainer>
          <Tooltip preferredPosition="topLeft" content={refreshTooltipLabel} disabled={canRefresh}>
            <Button
              testId="refresh-button"
              variant="text"
              label={refreshButtonLabel()}
              onClick={handleClickRefreshStatus}
              disabled={!canRefresh}
            />
          </Tooltip>
        </Styles.RefreshButtonContainer>
      </Styles.RightColumn>
    </Styles.Header>
  );
};

CloudFlareHeader.propTypes = {
  hostingLabel: PropTypes.string,
  changeCta: PropTypes.string,
  cloudflareCdnExplanation: PropTypes.object,
  searchPerDomainLabel: PropTypes.string,
  refreshStatusLabel: PropTypes.string,
  noOpenStatusLabel: PropTypes.string,
  waitRefreshTimeLimitLabel: PropTypes.string,
  handleRefreshStatus: PropTypes.func,
  setLastRefreshOnCookie: PropTypes.func,
  refreshTimeLimitHasEnded: PropTypes.bool,
  hasOpenStatus: PropTypes.bool,
  cloudflareStatusLoading: PropTypes.bool,
  inputedFilter: PropTypes.string,
  setInputedFilter: PropTypes.func,
  currentPlan: PropTypes.string,
  currentDomain: PropTypes.string,
  handleChangePlan: PropTypes.func,
  sites: PropTypes.array,
  title: PropTypes.string,
};

export default CloudFlareHeader;
